import { Shield } from 'lucide-react';
import React from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

interface AccessRestrictedProps {
    backMessage?: string;
    navigateTo?: string;
    accessMessage?: string;
    onBackClick?: () => void;
}

export default function AccessRestricted({ backMessage, navigateTo, accessMessage, onBackClick }: AccessRestrictedProps) {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col items-center justify-center h-[50vh] space-y-4">
            <Shield size={48} className="text-muted-foreground" />
            <h2 className="text-xl font-semibold">Access Restricted</h2>
            <p className="text-muted-foreground">{accessMessage || `You don't have permission to access this page.`}</p>
            <Button variant="outline" onClick={() => onBackClick ? onBackClick() : navigate(navigateTo || `/dashboard`)}>
                {backMessage || 'Back to Dashboard'}
            </Button>
        </div>
    );
}